import { Box, createIcon } from "@chakra-ui/icons";

export const ThreeExclamationMarkIcon = createIcon({
  displayName: "ThreeExclamationMarkIcon",
  viewBox: "0 0 24 24",
  d: "M8.123 16.001l.127-11h-1.5l.127 11h1.246zM7.5 18.999a.75.75 0 100-1.5.75.75 0 000 1.5zm5.123-2.998l.127-11h-1.5l.127 11h1.246zM12 18.999a.75.75 0 100-1.5.75.75 0 000 1.5zm5.123-2.998l.127-11h-1.5l.127 11h1.246zm-.623 2.998a.75.75 0 100-1.5.75.75 0 000 1.5z",
});

export const TwoExclamationMarkIcon = createIcon({
  displayName: "TwoExclamationMarkIcon",
  viewBox: "0 0 24 24",
  d: "M10.5 5.001l-.127 11H9.127L9 5.001h1.5zm0 13.248a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM15 5.001l-.127 11h-1.246l-.127-11H15zm0 13.248a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
});

export const OneExclamationMarkIcon = createIcon({
  displayName: "OneExclamationMarkIcon",
  viewBox: "0 0 24 24",
  d: "M12.623 16.001l.127-11h-1.5l.127 11h1.246zM12 18.999a.75.75 0 100-1.5.75.75 0 000 1.5z",
});

export const FlagIcon = createIcon({
  displayName: "FlagIcon",
  viewBox: "0 0 24 24",
  d: "M9.414 3.91c-1.94 0-2.965.562-3.67.954a8.24 8.24 0 01-.305.165L5 5.249v15.215h1.59v-7.527c.463-.13 1.25-.28 2.308-.28.846 0 1.604.314 2.531.711l.053.023c.871.374 1.906.817 3.104.817 1.94 0 2.965-.561 3.67-.953.122-.068.217-.12.305-.165l.44-.22L19 6.957V4.454l-1.15.575c-.208.103-1.182.433-2.748.433-.845 0-1.603-.314-2.53-.711l-.053-.023c-.872-.374-1.906-.817-3.105-.817z",
});

export const CloseIcon = createIcon({
  displayName: "CloseIcon",
  viewBox: "0 0 24 24",
  d: "M10.763 12L5.38 17.38l1.237 1.238L12 13.237l5.382 5.382 1.237-1.238L13.237 12l5.381-5.381-1.237-1.238L12 10.762l-5.38-5.38-1.238 1.237 5.38 5.38z",
});

export const ProjectIcon = createIcon({
  displayName: "ProjectIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0728 10.5L8.70772 8.5H4.5V18.5H19.5V10.5H10.0728ZM3 8C3 7.44771 3.44772 7 4 7H8.97181C9.3023 7 9.61145 7.16329 9.79776 7.43626L10.8651 9H20C20.5523 9 21 9.44772 21 10V19C21 19.5523 20.5523 20 20 20H4C3.44772 20 3 19.5523 3 19V8Z"
        fill="currentColor"
      />
      <mask
        id="mask0_5474_14332"
        maskUnits="userSpaceOnUse"
        x="5"
        y="4"
        width="18"
        height="4"
      >
        <path
          d="M6.5 5.5H5V4H23V7.5H12L6.5 5.5Z"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_5474_14332)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0728 7.5L10.7077 5.5H6.5V14.5H19.5V7.5H12.0728ZM5 5C5 4.44771 5.44772 4 6 4H10.9718C11.3023 4 11.6115 4.16329 11.7978 4.43626L12.8651 6H20C20.5523 6 21 6.44772 21 7V15C21 15.5523 22.5523 16 22 16H6C5.44772 16 5 15.5523 5 15V5Z"
          fill="currentColor"
        />
      </g>
    </>
  ),
});

export const AddIcon = createIcon({
  displayName: "AddIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        fill="currentColor"
        d="M18 12.75H6v-1.5h12v1.5z"
      />
      <path
        fill="currentColor"
        d="M11.25 18V6h1.5v12h-1.5z"
      />
      <path
        fill="currentColor"
        d="M18 12.75H6v-1.5h12v1.5z"
      />
      <path
        fill="currentColor"
        d="M11.25 18V6h1.5v12h-1.5z"
      />
    </>
  ),
});

export const DateIcon = createIcon({
  displayName: "DateIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 7.5V18.5H18.5V7.5H5.5ZM5 6C4.44772 6 4 6.44772 4 7V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V7C20 6.44772 19.5523 6 19 6H5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.25 6V3H8.75V6H7.25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.25 6V3H16.75V6H15.25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 11.75L4 11.75V10.25L20 10.25V11.75Z"
        fill="currentColor"
      />
    </>
  ),
});
export const SettingsIcon = createIcon({
  displayName: "SettingsIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 14.5C13.3807 14.5 14.5 13.3807 14.5 12C14.5 10.6193 13.3807 9.5 12 9.5C10.6193 9.5 9.5 10.6193 9.5 12C9.5 13.3807 10.6193 14.5 12 14.5ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.653 3.27319C14.2078 2.67149 15.1057 2.53474 15.8145 2.94399L17.9363 4.16899C18.6451 4.57823 18.9756 5.42413 18.7319 6.20551L18.4405 7.13989C18.4183 7.21106 18.4263 7.31948 18.5041 7.43C18.7742 7.81389 19.0113 8.22291 19.2112 8.65295C19.2683 8.77592 19.3584 8.83704 19.4311 8.85338L20.3841 9.06783C21.1827 9.2475 21.75 9.95666 21.75 10.7751V13.2251C21.75 14.0436 21.1827 14.7528 20.3841 14.9325L19.4311 15.1469C19.3584 15.1633 19.2683 15.2244 19.2112 15.3473C19.0111 15.7777 18.7738 16.1871 18.5034 16.5713C18.4256 16.6818 18.4176 16.7902 18.4398 16.8614L18.7312 17.7957C18.9748 18.577 18.6443 19.4229 17.9355 19.8322L15.8137 21.0572C15.1049 21.4664 14.2071 21.3297 13.6522 20.728L12.9894 20.0092C12.9389 19.9544 12.8411 19.9071 12.7066 19.919C12.4731 19.9396 12.2368 19.9501 11.9982 19.9501C11.7606 19.9501 11.5251 19.9397 11.2924 19.9192C11.1579 19.9074 11.0602 19.9547 11.0098 20.0094L10.3478 20.7273C9.79291 21.329 8.89509 21.4657 8.18626 21.0565L6.0645 19.8315C5.35567 19.4222 5.02518 18.5763 5.26884 17.795L5.55896 16.8646C5.58117 16.7934 5.57317 16.6849 5.49526 16.5744C5.22378 16.189 4.98559 15.7784 4.78493 15.3465C4.72778 15.2235 4.63768 15.1624 4.56503 15.146L3.61585 14.9325C2.81733 14.7528 2.25 14.0436 2.25 13.2251V10.7751C2.25 9.95666 2.81733 9.2475 3.61585 9.06783L4.56503 8.85427C4.63768 8.83792 4.72778 8.77679 4.78493 8.65379C4.98542 8.22229 5.22338 7.81195 5.49458 7.42691C5.57245 7.31636 5.58044 7.20787 5.55824 7.13666L5.26809 6.20622C5.02442 5.42484 5.35491 4.57894 6.06374 4.16969L8.1855 2.94469C8.89433 2.53545 9.79215 2.67219 10.347 3.2739L11.0083 3.99103C11.0588 4.04578 11.1565 4.09309 11.291 4.08122C11.5242 4.06064 11.7601 4.05015 11.9982 4.05015C12.2373 4.05015 12.474 4.06072 12.708 4.08144C12.8425 4.09336 12.9403 4.04604 12.9908 3.99127L13.653 3.27319ZM15.0645 4.24303C14.9632 4.18456 14.835 4.2041 14.7557 4.29006L14.0935 5.00814C13.6877 5.44823 13.1116 5.62307 12.5756 5.57559C12.3856 5.55876 12.193 5.55015 11.9982 5.55015C11.8042 5.55015 11.6123 5.5587 11.4229 5.57541C10.8871 5.6227 10.3113 5.44782 9.90559 5.00789L9.24429 4.29076C9.16502 4.2048 9.03676 4.18527 8.9355 4.24373L6.81374 5.46873C6.71248 5.52719 6.66527 5.64804 6.70008 5.75966L6.99023 6.69011C7.16876 7.26261 7.03133 7.84997 6.72092 8.29068C6.50076 8.60326 6.30776 8.93612 6.14527 9.28583C5.9185 9.7739 5.479 10.1861 4.89429 10.3177L3.94512 10.5312C3.83105 10.5569 3.75 10.6582 3.75 10.7751V13.2251C3.75 13.3421 3.83105 13.4434 3.94512 13.4691L4.8943 13.6826C5.479 13.8142 5.91851 14.2264 6.14527 14.7145C6.30789 15.0645 6.50108 15.3976 6.72147 15.7104C7.032 16.1511 7.1695 16.7386 6.99094 17.3112L6.70083 18.2415C6.66602 18.3531 6.71324 18.474 6.8145 18.5324L8.93626 19.7574C9.03752 19.8159 9.16578 19.7964 9.24505 19.7104L9.90703 18.9925C10.3126 18.5527 10.8883 18.3778 11.424 18.425C11.613 18.4416 11.8046 18.4501 11.9982 18.4501C12.1926 18.4501 12.3848 18.4416 12.5745 18.4248C13.1104 18.3774 13.6864 18.5523 14.0921 18.9923L14.755 19.7111C14.8342 19.7971 14.9625 19.8166 15.0637 19.7582L17.1855 18.5331C17.2868 18.4747 17.334 18.3538 17.2992 18.2422L17.0078 17.308C16.8294 16.7357 16.9666 16.1485 17.2768 15.7079C17.4963 15.396 17.6888 15.064 17.8509 14.7151C18.0777 14.2272 18.5172 13.815 19.1018 13.6835L20.0549 13.4691C20.169 13.4434 20.25 13.3421 20.25 13.2251V10.7751C20.25 10.6582 20.169 10.5569 20.0549 10.5312L19.1018 10.3168C18.5172 10.1853 18.0777 9.77312 17.8509 9.28515C17.6889 8.93663 17.4966 8.60484 17.2773 8.29319C16.9673 7.85257 16.8301 7.26552 17.0085 6.69334L17.2999 5.75896C17.3347 5.64733 17.2875 5.52649 17.1863 5.46803L15.0645 4.24303Z"
        fill="currentColor"
      />
    </>
  ),
});

export const TrashIcon = createIcon({
  displayName: "TrashIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.59861 3.49999L7 3.5C6.44772 3.5 6 3.94771 6 4.5L6 5L9.40139 4.99999L10.4014 3.5L13.5776 3.5L14.7443 5L18 5L18 4.5C18 3.94771 17.5523 3.49999 17 3.5L15.4779 3.5L14.3113 2L9.59861 2L8.59861 3.49999Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3302 8.5L6.66878 8.5L7.84735 19.5L16.1516 19.5L17.3302 8.5ZM18.8809 8.10653C18.9442 7.51547 18.4811 7 17.8866 7L6.11234 7C5.5179 7 5.05471 7.51547 5.11803 8.10653L6.40375 20.1065C6.45819 20.6147 6.88701 21 7.39806 21L16.6009 21C17.1119 21 17.5408 20.6147 17.5952 20.1065L18.8809 8.10653Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 8.5H4V7H20V8.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.25 17V11H10.75V17H9.25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.25 17V11H14.75V17H13.25Z"
        fill="currentColor"
      />
    </>
  ),
});

export const ArrowLeftIcon = createIcon({
  displayName: "ArrowLeftIcon",
  viewBox: "0 0 16 16",
  d: "M9.02006 3.33337L9.72716 4.04048L6.08072 7.68693L9.72716 11.3334L9.02006 12.0405L4.6665 7.68693L9.02006 3.33337Z",
});

export const ArrowRightIcon = createIcon({
  displayName: "ArrowRightIcon",
  viewBox: "0 0 16 16",
  d: "M6.9797 12L6.27259 11.2929L9.91904 7.64645L6.27259 4L6.9797 3.29289L11.3333 7.64645L6.9797 12Z",
});

// NOTE 다음 브랜치에서 폴더별 분리 예정
export const ArrowDownIcon = createIcon({
  displayName: "ArrowDownIcon",
  viewBox: "0 0 24 24",
  defaultProps: {
    boxSize: "1em", // 기본적으로 텍스트 크기 기준으로 크기 결정됨
    fill: "currentColor",
  },
  path: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5 9.46984L6.06066 8.40918L11.5303 13.8788L17 8.40918L18.0607 9.46984L11.5303 16.0002L5 9.46984Z"
        fill="white"
      />
    </svg>
  ),
});

export const NewFeatureIcon = createIcon({
  displayName: "NewFeatureIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.04251 6.57644L9.50076 5.09037L9.959 6.57644C10.1719 7.26686 10.6731 7.83142 11.3334 8.12463L13.3046 8.99992L11.3334 9.87522C10.6731 10.1684 10.1719 10.733 9.959 11.4234L9.50076 12.9095L9.04251 11.4234C8.82961 10.733 8.32842 10.1684 7.66809 9.87522L5.69689 8.99992L7.66809 8.12463C8.32842 7.83142 8.82961 7.26686 9.04251 6.57644ZM8.54516 3.09888C8.83515 2.15844 10.1664 2.15845 10.4564 3.09889L11.3924 6.13443C11.4776 6.4106 11.678 6.63642 11.9422 6.75371L14.9425 8.08598C15.7347 8.43776 15.7347 9.56209 14.9425 9.91387L11.9422 11.2461C11.678 11.3634 11.4776 11.5892 11.3924 11.8654L10.4564 14.901C10.1664 15.8414 8.83515 15.8414 8.54516 14.901L7.60911 11.8654C7.52395 11.5892 7.32348 11.3634 7.05934 11.2461L4.05901 9.91387C3.26679 9.56209 3.26679 8.43776 4.05901 8.08598L7.05934 6.75371C7.32348 6.63642 7.52395 6.4106 7.60911 6.13443L8.54516 3.09888ZM14.2461 17.6588C14.8199 17.3886 15.2666 16.912 15.5007 16.3291C15.7349 16.912 16.1816 17.3886 16.7553 17.6588L17.4801 18.0001L16.7553 18.3415C16.1816 18.6117 15.7349 19.0883 15.5007 19.6712C15.2666 19.0883 14.8199 18.6117 14.2461 18.3415L13.5213 18.0001L14.2461 17.6588ZM14.5405 14.3028C14.8199 13.3418 16.1815 13.3418 16.461 14.3029L16.8603 15.6762C16.9403 15.9517 17.1349 16.1795 17.3944 16.3017L19.0797 17.0954C19.845 17.4558 19.845 18.5444 19.0797 18.9048L17.3944 19.6985C17.1349 19.8207 16.9403 20.0485 16.8603 20.324L16.461 21.6974C16.1815 22.6585 14.8199 22.6585 14.5405 21.6974L14.1412 20.324C14.0611 20.0485 13.8666 19.8207 13.607 19.6985L11.9217 18.9048C11.1565 18.5444 11.1565 17.4558 11.9217 17.0954L13.607 16.3017C13.8666 16.1795 14.0611 15.9517 14.1412 15.6762L14.5405 14.3028Z"
        fill="currentColor"
      />
    </>
  ),
});
export const LogoIcon = createIcon({
  displayName: "LogoIcon",
  viewBox: "0 0 50 10",
  d: "M46.453 8h-4.968l-.947 2H38l4.77-10h2.445L50 10h-2.599l-.948-2zm-.78-1.757L43.978 2.27 42.28 6.243h3.394zM35.36 4.8a2.36 2.36 0 011.205.914c.29.42.435.938.435 1.557 0 .877-.307 1.553-.922 2.029-.606.467-1.494.7-2.664.7H27V0h6.158c1.093 0 1.93.233 2.51.7.59.467.884 1.1.884 1.9 0 .486-.107.919-.32 1.3-.205.38-.496.68-.871.9zm-6.298-3.057V4.1h3.84c.512 0 .9-.1 1.165-.3.265-.2.397-.495.397-.886 0-.39-.132-.68-.397-.871-.265-.2-.653-.3-1.165-.3h-3.84zm4.198 6.514c.547 0 .957-.1 1.23-.3.282-.2.422-.51.422-.928 0-.829-.55-1.243-1.652-1.243h-4.198v2.471h4.198zM19.5 10c-1.044 0-1.986-.216-2.829-.65a5.015 5.015 0 01-1.967-1.78C14.234 6.804 14 5.947 14 5c0-.948.235-1.8.704-2.555A4.98 4.98 0 0116.67.649C17.514.216 18.456 0 19.5 0c1.044 0 1.982.216 2.815.65a4.98 4.98 0 011.967 1.795C24.761 3.2 25 4.052 25 5c0 .948-.24 1.805-.718 2.57a5.016 5.016 0 01-1.967 1.78c-.833.434-1.771.65-2.815.65zm0-1.906c.594 0 1.13-.129 1.608-.387a2.88 2.88 0 001.12-1.105c.278-.47.417-1.003.417-1.602 0-.599-.139-1.133-.416-1.602a2.786 2.786 0 00-1.12-1.091 3.245 3.245 0 00-1.609-.4c-.594 0-1.13.133-1.608.4a2.883 2.883 0 00-1.135 1.09c-.268.47-.402 1.004-.402 1.603s.134 1.133.402 1.602c.278.47.656.838 1.135 1.105a3.337 3.337 0 001.608.387zM9.688 10l-.015-6L6.54 8H5.43L2.312 4.129V10H0V0h2.038L6 5.5 9.947 0h2.038v10H9.688z",
});

export const ProductFeedbackIcon = createIcon({
  displayName: "ProductFeedbackIcon",
  viewBox: "0 0 24 24",
  d: "M17 5l-4 5V5H9l-4 5V5H2v14h3l4-5v5h4l4-5v5h5V5h-5z",
});

export const MoreIcon = createIcon({
  displayName: "MoreIcon",
  viewBox: "0 0 24 24",
  d: "M5 10.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm5.5 1.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm8.5-1.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
});

export const CheckListIcon = createIcon({
  displayName: "CheckListIcon",
  viewBox: "0 0 24 24",
  d: "M6.469 12.03l1.06-1.06 2.97 2.97 5.97-5.97 1.06 1.06-7.03 7.03-4.03-4.03z",
});

export const CheckIcon = createIcon({
  displayName: "CheckIcon",
  viewBox: "0 0 14 14",
  d: "M2.60341 7.08103L3.22991 6.47019L5.97916 9.28993L11.3534 3.77788L11.9799 4.38872L5.97916 10.5433L2.60341 7.08103Z",
});

export const GrayCheckCircleIcon = createIcon({
  displayName: "GrayCheckCircleIcon",
  viewBox: "0 0 14 14",
  path: (
    <>
      <rect
        width="14"
        height="14"
        rx="7"
        fill="#ABADAD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5304 5.03033L6.02049 10.5402L2.49097 7.27806L3.50908 6.17649L5.97956 8.45981L10.4697 3.96967L11.5304 5.03033Z"
        fill="black"
      />
    </>
  ),
});

export const BlackCheckCircleIcon = createIcon({
  displayName: "BlackCheckCircleIcon",
  viewBox: "0 0 14 14",
  path: (
    <>
      <rect
        width="14"
        height="14"
        rx="7"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5304 5.03033L6.02049 10.5402L2.49097 7.27805L3.50908 6.17649L5.97956 8.45981L10.4697 3.96967L11.5304 5.03033Z"
        fill="white"
      />
    </>
  ),
});

export const GrayQuestionMarkCircle = createIcon({
  displayName: "GrayQuestionMarkCircle",
  viewBox: "0 0 14 14",
  path: (
    <>
      <rect
        width="14"
        height="14"
        rx="7"
        fill="black"
      />
      <path
        d="M6.09619 8.50861C6.10677 7.11785 6.4556 6.68043 7.08985 6.26545C7.5444 5.95141 7.89323 5.60372 7.89323 5.08779C7.89323 4.527 7.48097 4.15688 6.97357 4.15688C6.47674 4.15688 6.0222 4.50457 6.00106 5.1663H4.5C4.53171 3.58487 5.63108 2.83341 6.98414 2.83341C8.45349 2.83341 9.5 3.65217 9.5 5.03171C9.5 5.9514 9.05603 6.54584 8.35835 6.98326C7.76638 7.36459 7.50211 7.7235 7.49154 8.50861V8.63198H6.09619V8.50861ZM6.82558 11.373C6.32875 11.373 5.92706 10.9468 5.93763 10.4308C5.92706 9.9149 6.32875 9.49992 6.82558 9.49992C7.2907 9.49992 7.70296 9.9149 7.70296 10.4308C7.70296 10.9468 7.2907 11.373 6.82558 11.373Z"
        fill="#7C8183"
      />
    </>
  ),
});

export const RedXCircleIcon = createIcon({
  displayName: "RedXCircleIcon",
  viewBox: "0 0 14 14",
  path: (
    <>
      <rect
        width="14"
        height="14"
        rx="7"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.93945 7L3.46973 4.53027L4.53039 3.46961L7.00011 5.93934L9.46973 3.46973L10.5304 4.53039L8.06077 7L10.5304 9.46961L9.46973 10.5303L7.00011 8.06066L4.53039 10.5304L3.46973 9.46973L5.93945 7Z"
        fill="#FF6464"
      />
    </>
  ),
});

export const LocationIcon = createIcon({
  displayName: "LocationIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M18.215 10.67v-.008A6.34 6.34 0 0 0 18.25 10v-.056a6.25 6.25 0 0 0-12.5 0v.058c0 .223.012.444.035.66v.008l.001.007c.204 2.11 1.257 4.007 2.645 5.667 1.157 1.383 2.473 2.517 3.569 3.41 1.096-.893 2.412-2.027 3.569-3.41 1.388-1.66 2.441-3.557 2.645-5.667v-.007ZM12 22a88.906 88.906 0 0 0-.462-.372c-2.372-1.9-6.994-5.602-7.494-10.783A8.09 8.09 0 0 1 4 10v-.071a8 8 0 0 1 16 0V10c0 .286-.015.568-.044.845-.5 5.181-5.122 8.883-7.494 10.783L12 22Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 11.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 1.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
      />
    </>
  ),
});

export const MapIcon = createIcon({
  displayName: "MapIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.5 8.081v8.838l3.71-1.237a2.5 2.5 0 0 1 1.58 0L15 17.42l4.5-1.5V7.081l-3.71 1.237a2.5 2.5 0 0 1-1.58 0L9 6.58l-4.5 1.5Zm-.816-1.309A1 1 0 0 0 3 7.721v9.892a1 1 0 0 0 1.316.948l4.368-1.456a1 1 0 0 1 .632 0l5.368 1.79a1 1 0 0 0 .632 0l5-1.667a1 1 0 0 0 .684-.949V6.388a1 1 0 0 0-1.316-.95l-4.368 1.457a1 1 0 0 1-.632 0l-5.368-1.79a1 1 0 0 0-.632 0l-5 1.667Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.25 16V6h1.5v10h-1.5Zm6 2V8h1.5v10h-1.5Z"
      />
    </>
  ),
});

export const NoteIcon = createIcon({
  displayName: "NoteIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M18.5 4.5H9.621L5.5 8.621V19.5h13v-15ZM4.293 7.707A1 1 0 0 0 4 8.414V20a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H9.414a1 1 0 0 0-.707.293L4.293 7.707Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10.75 4v4A1.75 1.75 0 0 1 9 9.75H5v-1.5h4A.25.25 0 0 0 9.25 8V4h1.5ZM16 15.5H8V14h8v1.5Z"
      />
    </>
  ),
});

export const VisibilityDeepWorkIcon = createIcon({
  displayName: "VisibilityDeepWorkIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M12.75 4.035V2h-1.5v2.035a8.002 8.002 0 0 0-7.215 7.215H2v1.5h2.035a8.002 8.002 0 0 0 7.215 7.215V22h1.5v-2.035a8.002 8.002 0 0 0 7.215-7.215H22v-1.5h-2.035a8.002 8.002 0 0 0-7.215-7.215Zm-1.5 1.508V6.5h1.5v-.957a6.503 6.503 0 0 1 5.707 5.707H17.5v1.5h.957a6.503 6.503 0 0 1-5.707 5.707V17.5h-1.5v.957a6.503 6.503 0 0 1-5.707-5.707H6.5v-1.5h-.957a6.503 6.503 0 0 1 5.707-5.707ZM15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    />
  ),
});

export const VisibilityPublicIcon = createIcon({
  displayName: "VisibilityPublicIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12ZM14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 5C16 5 20.5 7.5 22 12C20.5 16.5 16 19 12 19C8 19 3.5 16.5 2 12C3.5 7.5 8 5 12 5ZM12 17.25C8.79498 17.25 5.26618 15.3282 3.86829 12C5.26618 8.67176 8.79498 6.75 12 6.75C15.205 6.75 18.7338 8.67175 20.1317 12C18.7338 15.3282 15.205 17.25 12 17.25Z"
        fill="currentColor"
      />
    </>
  ),
});

export const VisibilityInvisibleIcon = createIcon({
  displayName: "VisibilityPublicIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        d="M10 14.875H14V13.125H10V14.875Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7 5V9H5C4.44772 9 4 9.44771 4 10V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V10C20 9.44772 19.5523 9 19 9H16.75V5C16.75 3.96447 15.9105 3.125 14.875 3.125H8.875C7.83947 3.125 7 3.96447 7 5ZM8.875 4.875C8.80596 4.875 8.75 4.93096 8.75 5V9H15V5C15 4.93096 14.944 4.875 14.875 4.875H8.875ZM5.5 10.5V18.5H18.5V10.5H5.5Z"
        fill="currentColor"
      />
    </>
  ),
});

export const GoogleMeetHoverIcon = createIcon({
  displayName: "GoogleMeetHoverIcon",
  viewBox: "0 0 8 8",
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.87814 1.375L2.55936 1.375V0.5H6.93436H7.37186V0.9375V5.3125H6.49686V1.99372L1.11872 7.37186L0.5 6.75314L5.87814 1.375Z"
      fill="currentColor"
    />
  ),
});

export const RestoreIcon = createIcon({
  displayName: "RestoreIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4697 2.46973L14.5303 3.53039L11.0607 7.00006L14.5303 10.4697L13.4697 11.5304L8.93934 7.00006L13.4697 2.46973Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 13.0001C5 16.8661 8.13401 20.0001 12 20.0001C15.866 20.0001 19 16.8661 19 13.0001C19 9.13406 15.866 6.00006 12 6.00006C11.6605 6.00006 11.3266 6.02423 11 6.07095V7.59074C11.3243 7.53118 11.6585 7.50006 12 7.50006C15.0376 7.50006 17.5 9.96249 17.5 13.0001C17.5 16.0376 15.0376 18.5001 12 18.5001C8.96243 18.5001 6.5 16.0376 6.5 13.0001H5Z"
        fill="white"
      />
    </>
  ),
});

export const ToastCheckSuccessIcon = createIcon({
  displayName: "ToastCheckSuccessIcon",
  viewBox: "0 0 16 16",
  path: (
    <>
      <path
        d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z"
        fill="#69E4FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        fill="#0C0D0D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4697 4.96973L12.5303 6.03039L7 11.5607L3.96967 8.53039L5.03033 7.46973L7 9.4394L11.4697 4.96973Z"
        fill="#0C0D0D"
      />
    </>
  ),
});

export const ToastCheckDoneIcon = createIcon({
  displayName: "ToastCheckDoneIcon",
  viewBox: "0 0 16 16",
  path: (
    <>
      <path
        d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z"
        fill="#0C0D0D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        fill="#69E4FF"
        fill-opacity="0.3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4697 4.96973L12.5303 6.03039L7 11.5607L3.96967 8.53039L5.03033 7.46973L7 9.4394L11.4697 4.96973Z"
        fill="#69E4FF"
      />
    </>
  ),
});

export const ToastErrorIcon = createIcon({
  displayName: "ToastErrorIcon",
  viewBox: "0 0 17 17",
  path: (
    <>
      <rect
        x="1.07031"
        y="1"
        width="15"
        height="15"
        rx="7.5"
        fill="#FF6464"
        stroke="#202424"
      />
      <path
        d="M9.32227 5.42969L9.19531 10.3809H7.94531L7.81836 5.42969H9.32227ZM7.75977 11.7676C7.75 11.3184 8.12109 10.9521 8.58008 10.957C9.01465 10.9521 9.39062 11.3184 9.39062 11.7676C9.39062 12.2217 9.01465 12.5879 8.58008 12.5879C8.12109 12.5879 7.75 12.2217 7.75977 11.7676Z"
        fill="#1A1C1C"
      />
    </>
  ),
});

export const ToastDeleteIcon = createIcon({
  displayName: "ToastDeleteIcon",
  viewBox: "0 0 16 16",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.73241 2.33349L4.66667 2.33349C4.29848 2.33349 4 2.63197 4 3.00016L4 3.3335L6.26759 3.33349L6.93426 2.33349L9.05176 2.33349L9.82953 3.33349L12 3.3335L12 3.00016C12 2.63197 11.7015 2.33349 11.3333 2.33349L10.3186 2.33349L9.54084 1.33349L6.39908 1.33349L5.73241 2.33349Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5535 5.6665L4.44586 5.6665L5.23158 12.9998L10.7677 12.9998L11.5535 5.6665ZM12.5873 5.40419C12.6295 5.01015 12.3207 4.6665 11.9244 4.6665L4.07491 4.6665C3.67861 4.6665 3.36982 5.01015 3.41203 5.40419L4.26918 13.4042C4.30547 13.743 4.59135 13.9998 4.93205 13.9998L11.0673 13.9998C11.408 13.9998 11.6939 13.743 11.7301 13.4042L12.5873 5.40419Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3333 5.6665H2.66666V4.6665H13.3333V5.6665Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.16666 11.3335V7.3335H7.16666V11.3335H6.16666Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.83334 11.3335V7.3335H9.83334V11.3335H8.83334Z"
        fill="white"
      />
    </>
  ),
});

export const CopyIcon = createIcon({
  displayName: "CopyIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4 5C4 4.44772 4.44772 4 5 4H15C15.5523 4 16 4.44772 16 5V15C16 15.5523 15.5523 16 15 16H5C4.44772 16 4 15.5523 4 15V5ZM5.5 14.5V5.5H14.5V14.5H5.5Z"
        fill="white"
      />
      <path
        d="M18.5 18.5V8H19C19.5523 8 20 8.44772 20 9V19C20 19.5523 19.5523 20 19 20H9C8.44771 20 8 19.5523 8 19V18.5H18.5Z"
        fill="white"
      />
    </>
  ),
});

export const CalendarIcon = createIcon({
  displayName: "CalendarIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.5 7.5V18.5H18.5V7.5H5.5ZM5 6C4.44772 6 4 6.44772 4 7V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V7C20 6.44772 19.5523 6 19 6H5Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.25 6V3H8.75V6H7.25Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.25 6V3H16.75V6H15.25Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20 11.75H4V10.25H20V11.75Z"
        fill="currentColor"
      />
    </>
  ),
});

export const InboxIcon = createIcon({
  displayName: "InboxIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.04306 12.75H4V11.25H8.84583L10.1792 13.25H13.8208L15.1542 11.25H20V12.75H15.9569L14.6236 14.75H9.37639L8.04306 12.75Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.13145 6.5L4.5 12.2101V17.5H19.5V12.2101L17.8685 6.5H6.13145ZM5.7543 5C5.30782 5 4.91543 5.29598 4.79278 5.72528L3.03848 11.8653C3.01295 11.9547 3 12.0471 3 12.1401V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V12.1401C21 12.0471 20.987 11.9547 20.9615 11.8653L19.2072 5.72528C19.0846 5.29598 18.6922 5 18.2457 5H5.7543Z"
        fill="currentColor"
      />
    </>
  ),
});

// NOTE 디자인 문의 요청 중. 임시 설정 데이터
export const GoogleColoredIcon = createIcon({
  displayName: "GoogleColoredIcon",
  viewBox: "0 0 24 24",
  defaultProps: {
    width: "24px",
    height: "24px",
  },
  path: (
    <>
      {/* Google 로고의 색상별 부분 */}
      <Box as="g">
        <path
          d="M23.745 12.27c0-.79-.07-1.54-.19-2.27h-11.3v4.51h6.47c-.29 1.48-1.14 2.73-2.4 3.58v2.98h3.89c2.26-2.09 3.53-5.17 3.53-8.8z"
          fill="#4285F4"
        />
        <path
          d="M12.255 24c3.24 0 5.95-1.08 7.93-2.91l-3.89-2.98c-1.08.72-2.45 1.16-4.04 1.16-3.11 0-5.73-2.11-6.67-4.93h-4.02v3.09c1.97 3.92 6.02 6.57 10.69 6.57z"
          fill="#34A853"
        />
        <path
          d="M5.585 15.34c-.25-.72-.38-1.49-.38-2.28s.13-1.56.38-2.28v-3.09h-4.02c-.82 1.62-1.29 3.44-1.29 5.37s.47 3.75 1.29 5.37l4.02-3.09z"
          fill="#FBBC05"
        />
        <path
          d="M12.255 5.07c1.75 0 3.33.6 4.57 1.77l3.45-3.45c-2.07-1.94-4.78-3.13-8.02-3.13-4.67 0-8.72 2.65-10.69 6.57l4.02 3.09c.94-2.82 3.56-4.85 6.67-4.85z"
          fill="#EA4335"
        />
      </Box>
    </>
  ),
});
